import type { FC } from 'react';
import { Typography } from '@material-ui/core';

const Title: FC<any> = ({ title, align = 'center' }) => (
  <Typography component="span" align={align} variant="h6" color="#031f5e">
    {title}
  </Typography>
);

export default Title;
